import React from 'react';

import type { VariantProps } from 'tailwind-variants';
import { tv } from 'tailwind-variants';

import { cn } from '@avodah-inc/ui/utils';

import './themes.css';

export const themesVariants = tv({
  variants: {
    variant: {
      default: 'theme-default',
      telehealth: 'theme-telehealth',
      quickstart: 'theme-quickstart',
      embedded: 'theme-embedded',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

export type ThemeSwitcherProps = React.HTMLAttributes<HTMLDivElement> &
  VariantProps<typeof themesVariants>;

export const ThemeSwitcher = ({
  className,
  children,
  variant,
  ...props
}: ThemeSwitcherProps) => {
  return (
    <div
      className={cn(
        themesVariants({
          variant,
          className,
        }),
      )}
      {...props}
    >
      {children}
    </div>
  );
};
